import { render, staticRenderFns } from "./OrderPanels.vue?vue&type=template&id=ac043212&scoped=true&"
import script from "./OrderPanels.vue?vue&type=script&lang=js&"
export * from "./OrderPanels.vue?vue&type=script&lang=js&"
import style0 from "./OrderPanels.vue?vue&type=style&index=0&id=ac043212&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac043212",
  null
  
)

export default component.exports